export default __webpack_public_path__ + "static/media/sc.9973fb2c.png";